import { defineStore } from "pinia";

export const useModuleStore = defineStore("module", () => {
  const isPedometerEnabled = ref(localStorage.getItem("isPedometerEnabled") === "true" ? true : null);
  const isNotificationsEnabled = ref(localStorage.getItem("isNotificationsEnabled") === "true");

  function setPedometerEnabled(value) {
    if (typeof value !== "boolean") {
      console.error("Invalid value " + value + " for isPedometerEnabled", new Error());
    }
    isPedometerEnabled.value = !!value;
    localStorage.setItem("isPedometerEnabled", JSON.stringify(isPedometerEnabled.value));
  }

  function setNotificationsEnabled(value) {
    if (typeof value !== "boolean") {
      console.error("Invalid value " + value + " for isNotificationsEnabled", new Error());
    }
    isNotificationsEnabled.value = !!value;
    localStorage.setItem("isNotificationsEnabled", JSON.stringify(isNotificationsEnabled.value));
  }

  return {
    isPedometerEnabled,
    isNotificationsEnabled,
    setPedometerEnabled,
    setNotificationsEnabled,
  };
});
